import { ErrorLogComponent } from '@cian/error-log-component';

import { ComponentProps } from 'react';

import { useApplicationContext } from 'shared/context/ApplicationContext';
import { memoWithDisplayName } from 'shared/utils/memoWithDisplayName';

type ErrorLogContainerProps = Omit<ComponentProps<typeof ErrorLogComponent>, 'logger'>;

export const ErrorLogContainer = memoWithDisplayName<ErrorLogContainerProps>(props => {
  const { logger } = useApplicationContext();

  return <ErrorLogComponent {...props} logger={logger} />;
}, 'ErrorLogContainer');
